import { List, ListItemButton, ListItemText, Paper, Popover, Typography } from '@mui/material';
import { MentionUser } from './mentionUtils';

export interface MentionAutocompleteProps {
  open: boolean;
  /** Coordinate viewport del cursore (da Range.getBoundingClientRect()). */
  anchor: { top: number; left: number } | null;
  members: MentionUser[];
  loading?: boolean;
  onSelect: (user: MentionUser) => void;
  onClose: () => void;
}

const MentionAutocomplete = ({
  open,
  anchor,
  members,
  loading,
  onSelect,
  onClose,
}: MentionAutocompleteProps) => {
  if (!anchor) return null;

  return (
    <Popover
      open={open}
      anchorReference="anchorPosition"
      anchorPosition={anchor}
      onClose={onClose}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <Paper sx={{ maxHeight: 240, minWidth: 260, overflowY: 'auto' }}>
        {members.length === 0 ? (
          <Typography variant="body2" sx={{ p: 1.5, color: 'text.secondary' }}>
            {loading ? '…' : 'Nessun utente'}
          </Typography>
        ) : (
          <List dense disablePadding>
            {members.map((u) => (
              <ListItemButton
                key={u.id}
                // Non rubare il focus al contenteditable: se il click sposta il
                // focus qui, l'editor viene blurrato e la selezione (dove è
                // scritto "@query") si perde → la menzione non viene inserita.
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onSelect(u)}
              >
                <ListItemText
                  primary={`${u.firstname ?? ''} ${u.lastname ?? ''}`.trim()}
                  secondary={u.email}
                />
              </ListItemButton>
            ))}
          </List>
        )}
      </Paper>
    </Popover>
  );
};

export default MentionAutocomplete;
